<template>
  <a-layout-content>
    <h2>欢迎来到JOYland-Auction赛事系统</h2>
    <h3>by 集英商学社学术研究中心&信息技术中心JOYland团队</h3>
    <h2>当前赛事：{{this.data.name}}</h2>
    <h3 v-if='this.data.control'>当前赛事处于开放状态</h3>
    <h3 v-else>当前赛事处于关闭状态</h3>
    <a-row>
      <a-col :span="16">
        <p></p>
        <a-button type="primary" size="large" @click="push('login')">登录赛事系统</a-button>
      </a-col>
    </a-row><br>
    <!--<img :src="this.data.haibao_img" style="width:30%">-->
  </a-layout-content>
</template>

<script>
export default {
  data () {
    return {
      data: []
    }
  },
  created () {
    this.$http.get('https://auction-api.joyland.top/system').then(res => {
      this.data = res.data
    })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    }
  }
}
</script>

<style>
</style>
